import { Dialog } from '@mui/material';
import { DialogProps } from '@mui/material/Dialog/Dialog';

export type TSharedDialogProps = DialogProps;

export default function SharedDialog(props: TSharedDialogProps) {
  return <Dialog {...props} />;
}